module.exports = __webpack_public_path__ + "fonts/VistaSansOT-Light.6907f7c8.otf";